var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "arrow2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.423,
    height: 17.14,
    viewBox: "0 0 24.423 17.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M24.017,9.548h0l-7.223,7.188a1.382,1.382,0,0,1-1.95-1.959l4.849-4.826-18.31-.1a1.382,1.382,0,1,1,0-2.764l18.31.1L14.843,2.362A1.382,1.382,0,0,1,16.794.4L24.016,7.59h0A1.383,1.383,0,0,1,24.017,9.548Z",
    fill: "#ed193a"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right_arrow.bb81534aabb4b07315ba30fbfd506df5.svg";
export { ForwardRef as ReactComponent };